import { render } from "./attivazioneAccount.html?vue&type=template&id=1f1cfc22&scoped=true&external"
import script from "./AttivazioneAccount.vue?vue&type=script&lang=js"
export * from "./AttivazioneAccount.vue?vue&type=script&lang=js"

import "./AttivazioneAccount.vue?vue&type=style&index=0&id=1f1cfc22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1cfc22"]])

export default __exports__